import { BaseModel } from "paliari-js-utils"
import { required, requiredIf } from "vuelidate/lib/validators"

export const attributes = () => ({
  paf: "",
  obs: "",
  revisado: false,
  protocolo: "",
  revisao_obs: "",
})

export default class Implantacao extends BaseModel {
  constructor(obj) {
    super(attributes(), obj)
  }

  static get validations() {
    return {
      paf: {},
      obs: { required },
      revisado: {},
      protocolo: { required: requiredIf(nested => nested.revisado) },
      revisao_obs: { required: requiredIf(nested => nested.revisado) },
    }
  }
}
